export enum CarFilterType {
  AdditionalServices = 'additionalServices',
  CarClass = 'carClass',
  DepositPaymentMethod = 'depositPaymentMethod',
  PickUpLocation = 'pickUpLocation',
  Transmission = 'transmission',
  FuelType = 'fuelType',
}

export interface CarFilters {
  [CarFilterType.AdditionalServices]: MultiValueFilter
  [CarFilterType.CarClass]: SingleValueFilter
  [CarFilterType.DepositPaymentMethod]: SingleValueFilter
  [CarFilterType.PickUpLocation]: SingleValueFilter
  [CarFilterType.Transmission]: SingleValueFilter
  [CarFilterType.FuelType]: SingleValueFilter
}

export interface CarFilter {
  type: string
  filterOptions: CarFilterOption[]
}

export interface CarFilterOption {
  name: string
  value: string
  quantity: number | null
  startingPrice: number | null
}

export interface SingleValueFilter extends CarFilter {
  selectedFilter: string | null
}

export interface MultiValueFilter extends CarFilter {
  selectedFilters: string[]
}
